
import { SEOData, defaultSEO, pageSEOData } from '@/data/seoData';

export const getSEOData = (pathname: string): SEOData => {
  return pageSEOData[pathname] || defaultSEO;
};

export const generateStructuredData = (data: any) => {
  return JSON.stringify(data);
};

export const generateSitemap = (routes: string[]) => {
  const baseUrl = 'https://juvmedspa.com';
  const currentDate = new Date().toISOString().split('T')[0];
  
  const urlSet = routes.map(route => `
    <url>
      <loc>${baseUrl}${route}</loc>
      <lastmod>${currentDate}</lastmod>
      <changefreq>weekly</changefreq>
      <priority>${route === '/' ? '1.0' : '0.8'}</priority>
    </url>
  `).join('');

  return `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  ${urlSet}
</urlset>`;
};

export const generateRobotsTxt = () => {
  return `User-agent: *
Allow: /

User-agent: Googlebot
Allow: /

User-agent: Bingbot
Allow: /

Sitemap: https://juvmedspa.com/sitemap.xml

# JUV Medspa™ - Premium Aesthetic Treatments
`;
};
